<template>
  <div :class="`form-element form-${type}-element`">
    <h4 v-if="options.title">{{ options.title }}</h4>

    <FormBarcodeElement
      type="barcode"
      :options="{ title: $t('form.elements.barcode.name') }"
      @input="barcodeInput"
    />

    <FormCheckboxElement
      v-model="barcodeDefect"
      class="mt-3"
      type="checkbox"
      :options="{ title: $t('form.elements.barcode.code_defect') }"
    />

    <FormGroupElement
      v-if="barcodeDefect"
      class="mt-3"
      type="form_group"
      v-model="internalValue"
      :elements="elements"
      :form-doc="formDoc"
      :form-data="formData"
    />
  </div>
</template>

<script>
import FormCheckboxElement from './FormCheckboxElement';
import FormBarcodeElement from './FormBarcodeElement';
import FormGroupElement from './FormGroupElement';

export default {
  components: {
    FormCheckboxElement,
    FormBarcodeElement,
    FormGroupElement
  },
  props: {
    elements: { type: [Array], default: null },
    value: { type: [String, Object], default () { return null; } },
    type: { type: String, required: true },
    formDoc: { type: String, required: true },
    formData: { type: Object, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      barcodeDefect: false,
      parsing: {
        prefix: null,
        suffix: null,
        separator: null,
        elements: {}
      }
    };
  },
  computed: {
    internalValue: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    }
  },
  watch: {
    'options.parsing': {
      handler (value) {
        for (let key of ['prefix', 'suffix', 'separator']) {
          if (value[key]) {
            this.parsing[key] = (value[key + 'IsHex']) ? this.hexToAscii(value[key]) : value[key];
          }
        }

        for (let key in value.elements) {
          if (value.elements[key].assignment_by === 'prefix') {
            let prefix = value.elements[key].assignment_prefix;
            if (value.elements[key].assignment_prefix_is_hex) {
              prefix = this.hexToAscii(prefix);
            }

            this.parsing.elements[key] = { prefix };
          } else if (value.elements[key].assignment_by === 'index') {
            this.parsing.elements[key] = { index: +value.elements[key].assignment_index };
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    barcodeInput (value) {
      if (this.parsing.prefix) {
        let prefixIndex = value.indexOf(this.parsing.prefix);
        if (prefixIndex === -1) {
          // TODO: error invalid input
          alert('Invalid input');
          return;
        }

        value = value.substr(prefixIndex + this.parsing.prefix.length);
      }

      if (this.parsing.suffix) {
        let suffixIndex = value.indexOf(this.parsing.suffix);
        if (suffixIndex === -1) {
          // TODO: error invalid input
          alert('Invalid input');
          return;
        }

        value = value.substr(0, suffixIndex);
      }

      if (this.parsing.separator) {
        value = value.split(this.parsing.separator);
      } else {
        value = [value];
      }

      let result = {};
      for (let elKey in this.parsing.elements) {
        let el = this.parsing.elements[elKey];
        if (el.prefix) {
          for (let field of value) {
            if (field.startsWith(el.prefix)) {
              result[elKey] = field.substr(el.prefix.length);
              break;
            }
          }
        } else if (el.index !== undefined) {
          result[elKey] = value[el.index];
        }
      }

      this.internalValue = result;
    },
    hexToAscii(str1) {
      let hex  = str1.toString();
      let str = '';
      for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
      }
      return str;
    }
  },
};
</script>
